import React, { FunctionComponent, useEffect, useState } from 'react'
import styled from '@emotion/styled'
import CollectionsList from './CollectionsList/CollectionsList'
import CollectionsSearch from './CollectionsList/CollectionsSearch/CollectionsSearch'
import CollectionModal from './CollectionsList/CollectionModal/CollectionModal'

const StyledContainer = styled.div`
  position: relative;
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

interface IProps {
  userId: number
}

const Collections: FunctionComponent<any> = (props: IProps) => {

  const { userId } = props

  const [search, setSearch] = useState<string>('')

  const [selectedCollection, setSelectedCollection] = useState<any>(null)
  const [open, setOpen] = useState<boolean>(false)

  useEffect(() => {
    setOpen(!!selectedCollection)
  }, [selectedCollection])

  return (
    <StyledContainer>
      <CollectionsSearch setSearch={setSearch} />
      <CollectionsList userId={userId} search={search} setOpen={setOpen} setSelectedCollection={setSelectedCollection} />
      <CollectionModal
        userId={userId}
        open={open}
        setOpen={setOpen}
        selectedCollection={selectedCollection}
        setSelectedCollection={setSelectedCollection}
        initTargetKeys={[]}
      />
    </StyledContainer>
  )
}

export default Collections
